import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const ProfileIconSelector = ({ selectedIcon, onIconSelect, error }) => {
  const { language } = useLanguage();
  const [availableIcons, setAvailableIcons] = useState([]);

  useEffect(() => {
    const icons = [
      { id: 'icons8-aang-50', name: 'Aang', filename: 'icons8-aang-50.png' },
      { id: 'icons8-amethyst-universe-50', name: 'Amethyst Universe', filename: 'icons8-amethyst-universe-50.png' },
      { id: 'icons8-anonymous-mask-50', name: 'Anonymous Mask', filename: 'icons8-anonymous-mask-50.png' },
      { id: 'icons8-aquaman-50', name: 'Aquaman', filename: 'icons8-aquaman-50.png' },
      { id: 'icons8-atom-50', name: 'Atom', filename: 'icons8-atom-50.png' },
      { id: 'icons8-avengers-50', name: 'Avengers', filename: 'icons8-avengers-50.png' },
      { id: 'icons8-baby-yoda-50', name: 'Baby Yoda', filename: 'icons8-baby-yoda-50.png' },
      { id: 'icons8-badtz-maru-50', name: 'Badtz Maru', filename: 'icons8-badtz-maru-50.png' },
      { id: 'icons8-batman-50', name: 'Batman', filename: 'icons8-batman-50.png' },
      { id: 'icons8-batman-logo-50', name: 'Batman Logo', filename: 'icons8-batman-logo-50.png' },
      { id: 'icons8-brave-50', name: 'Brave', filename: 'icons8-brave-50.png' },
      { id: 'icons8-brutus-50', name: 'Brutus', filename: 'icons8-brutus-50.png' },
      { id: 'icons8-captain-america-50', name: 'Captain America', filename: 'icons8-captain-america-50.png' },
      { id: 'icons8-cheburashka-50', name: 'Cheburashka', filename: 'icons8-cheburashka-50.png' },
      { id: 'icons8-chip-50', name: 'Chip', filename: 'icons8-chip-50.png' },
      { id: 'icons8-dale-50', name: 'Dale', filename: 'icons8-dale-50.png' },
      { id: 'icons8-darth-vader-50', name: 'Darth Vader', filename: 'icons8-darth-vader-50.png' },
      { id: 'icons8-deadpool-50', name: 'Deadpool', filename: 'icons8-deadpool-50.png' },
      { id: 'icons8-fairy-50', name: 'Fairy', filename: 'icons8-fairy-50.png' },
      { id: 'icons8-fantastic-four-50', name: 'Fantastic Four', filename: 'icons8-fantastic-four-50.png' },
      { id: 'icons8-finding-nemo-50', name: 'Finding Nemo', filename: 'icons8-finding-nemo-50.png' },
      { id: 'icons8-gambit-50', name: 'Gambit', filename: 'icons8-gambit-50.png' },
      { id: 'icons8-genie-50', name: 'Genie', filename: 'icons8-genie-50.png' },
      { id: 'icons8-goofy-50', name: 'Goofy', filename: 'icons8-goofy-50.png' },
      { id: 'icons8-grim-adventures-of-billy-and-mandy-50', name: 'Grim Adventures', filename: 'icons8-grim-adventures-of-billy-and-mandy-50.png' },
      { id: 'icons8-groot-50', name: 'Groot', filename: 'icons8-groot-50.png' },
      { id: 'icons8-hawkeye-50', name: 'Hawkeye', filename: 'icons8-hawkeye-50.png' },
      { id: 'icons8-hulk-50', name: 'Hulk', filename: 'icons8-hulk-50.png' },
      { id: 'icons8-iron-man-50', name: 'Iron Man', filename: 'icons8-iron-man-50.png' },
      { id: 'icons8-joker-dc-50', name: 'Joker DC', filename: 'icons8-joker-dc-50.png' },
      { id: 'icons8-lala-50', name: 'Lala', filename: 'icons8-lala-50.png' },
      { id: 'icons8-launchpad-mcquack-50', name: 'Launchpad McQuack', filename: 'icons8-launchpad-mcquack-50.png' },
      { id: 'icons8-louie-50', name: 'Louie', filename: 'icons8-louie-50.png' },
      { id: 'icons8-madagascar-50', name: 'Madagascar', filename: 'icons8-madagascar-50.png' },
      { id: 'icons8-magneto-50', name: 'Magneto', filename: 'icons8-magneto-50.png' },
      { id: 'icons8-morty-smith-50', name: 'Morty Smith', filename: 'icons8-morty-smith-50.png' },
      { id: 'icons8-ninja-turtle-50', name: 'Ninja Turtle', filename: 'icons8-ninja-turtle-50.png' },
      { id: 'icons8-peter-pan-50', name: 'Peter Pan', filename: 'icons8-peter-pan-50.png' },
      { id: 'icons8-scooby-doo-50', name: 'Scooby Doo', filename: 'icons8-scooby-doo-50.png' },
      { id: 'icons8-scooby-doo-daphne-blake-50', name: 'Daphne Blake', filename: 'icons8-scooby-doo-daphne-blake-50.png' },
      { id: 'icons8-scooby-doo-fred-jones-50', name: 'Fred Jones', filename: 'icons8-scooby-doo-fred-jones-50.png' },
      { id: 'icons8-scooby-doo-shaggy-rogers-50', name: 'Shaggy Rogers', filename: 'icons8-scooby-doo-shaggy-rogers-50.png' },
      { id: 'icons8-scooby-doo-velma-dinkley-50', name: 'Velma Dinkley', filename: 'icons8-scooby-doo-velma-dinkley-50.png' },
      { id: 'icons8-scrooge-mcduck-50', name: 'Scrooge McDuck', filename: 'icons8-scrooge-mcduck-50.png' },
      { id: 'icons8-shrek-50', name: 'Shrek', filename: 'icons8-shrek-50.png' },
      { id: 'icons8-simba-50', name: 'Simba', filename: 'icons8-simba-50.png' },
      { id: 'icons8-smurf-50', name: 'Smurf', filename: 'icons8-smurf-50.png' },
      { id: 'icons8-sokka-50', name: 'Sokka', filename: 'icons8-sokka-50.png' },
      { id: 'icons8-spider-man-head-50', name: 'Spider Man', filename: 'icons8-spider-man-head-50.png' },
      { id: 'icons8-spongebob-squarepants-50', name: 'Spongebob', filename: 'icons8-spongebob-squarepants-50.png' },
      { id: 'icons8-thanos-50', name: 'Thanos', filename: 'icons8-thanos-50.png' },
      { id: 'icons8-the-coon-50', name: 'The Coon', filename: 'icons8-the-coon-50.png' },
      { id: 'icons8-the-flash-head-50', name: 'The Flash', filename: 'icons8-the-flash-head-50.png' },
      { id: 'icons8-thor-50', name: 'Thor', filename: 'icons8-thor-50.png' },
      { id: 'icons8-timon-50', name: 'Timon', filename: 'icons8-timon-50.png' },
      { id: 'icons8-tom-50', name: 'Tom', filename: 'icons8-tom-50.png' },
      { id: 'icons8-toph-50', name: 'Toph', filename: 'icons8-toph-50.png' },
      { id: 'icons8-totoro-50', name: 'Totoro', filename: 'icons8-totoro-50.png' },
      { id: 'icons8-venom-head-50', name: 'Venom', filename: 'icons8-venom-head-50.png' },
      { id: 'icons8-wolverine-50', name: 'Wolverine', filename: 'icons8-wolverine-50.png' },
      { id: 'icons8-zuko-50', name: 'Zuko', filename: 'icons8-zuko-50.png' },
      { id: 'icons8-gandalf-50', name: 'Gandalf', filename: 'icons8-gandalf-50.png' },
      { id: 'icons8-legolas-50', name: 'Legolas', filename: 'icons8-legolas-50.png' },
      { id: 'icons8-gollum-50', name: 'Gollum', filename: 'icons8-gollum-50.png' },
      { id: 'icons8-call-of-duty-warzone-50', name: 'COD Warzone', filename: 'icons8-call-of-duty-warzone-50.png' },
      { id: 'icons8-frodo-50', name: 'Frodo', filename: 'icons8-frodo-50.png' },
      { id: 'icons8-monarch-50', name: 'Monarch', filename: 'icons8-monarch-50.png' }
    ];
    setAvailableIcons(icons);
  }, []);

  return (
    <div className="space-y-3">
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
        {language === 'tr' ? 'Profil İkonu' : 'Profile Icon'}
        <span className="text-red-500 ml-1">*</span>
      </label>
      <div className="grid grid-cols-8 gap-3 max-h-80 overflow-y-auto border border-gray-200 dark:border-gray-600 rounded-lg p-4">
        {availableIcons.map((icon) => (
          <button
            key={icon.id}
            type="button"
            onClick={() => onIconSelect(icon.id)}
            className={`
              w-12 h-12 flex items-center justify-center rounded-lg border-2 transition-all duration-200 overflow-hidden
              ${selectedIcon === icon.id
                ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20 shadow-md'
                : 'border-gray-200 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500 hover:bg-gray-50 dark:hover:bg-gray-700'
              }
            `}
            title={icon.name}
          >
            <img
              src={`/profile-icons/${icon.filename}`}
              alt={icon.name}
              className="w-8 h-8 object-contain"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <span className="text-xs text-gray-400 hidden">?</span>
          </button>
        ))}
      </div>
      {selectedIcon && (
        <div className="flex items-center space-x-2 text-sm text-gray-600 dark:text-gray-400">
          <span>{language === 'tr' ? 'Seçilen ikon:' : 'Selected icon:'}</span>
          <img
            src={`/profile-icons/${availableIcons.find(icon => icon.id === selectedIcon)?.filename}`}
            alt={availableIcons.find(icon => icon.id === selectedIcon)?.name}
            className="w-6 h-6 object-contain"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'block';
            }}
          />
          <span className="text-xs text-gray-400 hidden">?</span>
          <span className="font-medium">
            {availableIcons.find(icon => icon.id === selectedIcon)?.name}
          </span>
        </div>
      )}
      {error && (
        <p className="text-sm text-red-600 dark:text-red-400">{error}</p>
      )}
    </div>
  );
};

export default ProfileIconSelector;
